var _defs, _path, _path2, _g, _g2, _g3, _g4, _g5, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCosmos(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    height: 500,
    viewBox: "0 0 132.292 132.292",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "cosmos-h"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0e0327"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#3a0ca3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7209b7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cosmos-g"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4cc9f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.166,
    stopColor: "#c143ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#0e0ca3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3a0ca3",
    stopOpacity: 0.03
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cosmos-f"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4cc9f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.166,
    stopColor: "#4361ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#3a0ca3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3a0ca3",
    stopOpacity: 0.03
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cosmos-d"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9d0208"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4f0204"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cosmos-e"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8910a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dc2f02"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cosmos-c"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9d0208"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#740206"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cosmos-b"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6a040f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48020a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cosmos-a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#03045e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01012a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cosmos-l",
    x1: 181.908,
    x2: 211.113,
    y1: 49.194,
    y2: 81.517,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#cosmos-b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cosmos-m",
    x1: 161.76,
    x2: 235.909,
    y1: 100.734,
    y2: 116.343,
    gradientTransform: "matrix(.92037 0 0 .88943 16.643 11.354)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#cosmos-c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cosmos-n",
    x1: 152.921,
    x2: 202.021,
    y1: 68.363,
    y2: 103.658,
    gradientTransform: "translate(2.03 -.32)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#cosmos-d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cosmos-p",
    x1: 177.266,
    x2: 203.601,
    y1: 98.559,
    y2: 109.778,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#cosmos-e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cosmos-o",
    x1: 177.788,
    x2: 183.399,
    y1: 155.683,
    y2: 161.219,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#cosmos-e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cosmos-j",
    x1: 181.908,
    x2: 211.113,
    y1: 49.194,
    y2: 81.517,
    gradientTransform: "matrix(.90427 0 0 .86752 -14.01 -19.473)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#cosmos-b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cosmos-q",
    x1: 155.102,
    x2: 155.102,
    y1: 57.072,
    y2: 25.595,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad",
    xlinkHref: "#cosmos-f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cosmos-t",
    x1: 155.102,
    x2: 155.102,
    y1: 57.072,
    y2: 25.595,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad",
    xlinkHref: "#cosmos-g"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cosmos-v",
    x1: 180.249,
    x2: 255.105,
    y1: 71.934,
    y2: 143.192,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#cosmos-h"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "cosmos-k",
    width: 1.099,
    height: 1.1,
    x: -0.05,
    y: -0.05,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.491
  })), /*#__PURE__*/React.createElement("filter", {
    id: "cosmos-s",
    width: 1.79,
    height: 1.728,
    x: -0.395,
    y: -0.364,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.399
  })), /*#__PURE__*/React.createElement("filter", {
    id: "cosmos-r",
    width: 1.407,
    height: 1.033,
    x: -0.203,
    y: -0.017,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.227
  })), /*#__PURE__*/React.createElement("filter", {
    id: "cosmos-u",
    width: 1.568,
    height: 1.637,
    x: -0.284,
    y: -0.318,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.669
  })), /*#__PURE__*/React.createElement("filter", {
    id: "cosmos-w",
    width: 1.553,
    height: 1.623,
    x: -0.277,
    y: -0.312,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.293
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "cosmos-i",
    cx: 98.768,
    cy: 96.463,
    r: 66.146,
    fx: 98.768,
    fy: 96.463,
    gradientTransform: "matrix(2.20732 .19903 -.09143 1.014 -88.023 -15.209)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#cosmos-a"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cosmos-i)",
    fillRule: "evenodd",
    d: "M0 0h132.292v132.292H0z",
    paintOrder: "fill markers stroke"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cosmos-j)",
    fillRule: "evenodd",
    d: "M207.511 46.789A36.051 35.673 0 01171.46 82.46a36.051 35.673 0 01-36.051-35.672 36.051 35.673 0 0136.051-35.673 36.051 35.673 0 0136.051 35.673z",
    filter: "url(#cosmos-k)",
    paintOrder: "fill markers stroke",
    transform: "translate(-105.314 19.357)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1.129,
    transform: "matrix(.90427 0 0 .86752 -119.325 -.116)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 205.104,
    cy: 76.38,
    fill: "url(#cosmos-l)",
    fillRule: "evenodd",
    paintOrder: "fill markers stroke",
    rx: 39.868,
    ry: 41.12
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cosmos-m)",
    d: "M218.887 78.26c-.898.012-1.863.162-2.904.481-13.334 4.082-2.13 17.317-7.263 20.358-5.133 3.04-9.668-19.316-13.557-2.587-3.299 14.185-18.848 5.278-23.513 2.234a38.677 38.55 0 0031.506 16.19 38.677 38.55 0 0038.547-35.408c-1.52 1-3.424 2.74-5.41 6.63-5.656 11.073-6.813-8.042-17.406-7.898z",
    opacity: 0.747
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 185.068,
    cy: 88.895,
    fill: "url(#cosmos-n)",
    fillRule: "evenodd",
    opacity: 0.747,
    paintOrder: "fill markers stroke",
    rx: 24.482,
    ry: 14.406,
    transform: "matrix(.98035 -.19726 .2121 .97725 0 0)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 180.542,
    cy: 155.683,
    fill: "url(#cosmos-o)",
    fillRule: "evenodd",
    opacity: 0.747,
    paintOrder: "fill markers stroke",
    rx: 2.754,
    ry: 1.403,
    transform: "matrix(.8358 -.54903 .26569 .96406 0 0)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 199.972,
    cy: 100.041,
    fill: "url(#cosmos-p)",
    fillRule: "evenodd",
    opacity: 0.747,
    paintOrder: "fill markers stroke",
    rx: 10.885,
    ry: 4.726,
    transform: "matrix(.96076 -.27737 .14247 .9898 0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cb6906",
    fillRule: "evenodd",
    d: "M174.605 68.108a4.295 5.252 17.326 00-.042 0 4.295 5.252 17.326 00-.09.003 4.295 5.252 17.326 00-.09.005 4.295 5.252 17.326 00-.082.005 4.295 5.252 17.326 00-.013.001 4.295 5.252 17.326 00-.085.008 4.295 5.252 17.326 00-.075.01 4.295 5.252 17.326 00-.037.004 4.295 5.252 17.326 00-.068.01 4.295 5.252 17.326 00-.084.014 4.295 5.252 17.326 00-.018.003 4.295 5.252 17.326 00-.079.015 4.295 5.252 17.326 00-.09.02 4.295 5.252 17.326 00-.089.02 4.295 5.252 17.326 00-.074.02 4.295 5.252 17.326 00-.031.009 4.295 5.252 17.326 00-.059.017 4.295 5.252 17.326 00-.033.01 4.295 5.252 17.326 00-.029.008 4.295 5.252 17.326 00-.042.014 4.295 5.252 17.326 00-.088.03 4.295 5.252 17.326 00-.002 0 4.295 5.252 17.326 00-.087.032 4.295 5.252 17.326 00-.083.032 4.295 5.252 17.326 00-.01.004 4.295 5.252 17.326 00-.075.031 4.295 5.252 17.326 00-.017.007 4.295 5.252 17.326 00-.078.035 4.295 5.252 17.326 00-.08.036 4.295 5.252 17.326 00-.02.01 4.295 5.252 17.326 00-.052.025 4.295 5.252 17.326 00-.049.025 4.295 5.252 17.326 00-.052.027 4.295 5.252 17.326 00-.009.004 4.295 5.252 17.326 00-.082.045 4.295 5.252 17.326 00-.085.049 4.295 5.252 17.326 00-.084.05 4.295 5.252 17.326 00-.083.052 4.295 5.252 17.326 00-.083.054 4.295 5.252 17.326 00-.06.04 4.295 5.252 17.326 00-.04.029 4.295 5.252 17.326 00-.062.044 4.295 5.252 17.326 00-.08.06 4.295 5.252 17.326 00-.079.061 4.295 5.252 17.326 00-.078.063 4.295 5.252 17.326 00-.077.065 4.295 5.252 17.326 00-.067.059 4.295 5.252 17.326 00-.015.013 4.295 5.252 17.326 00-.068.06 4.295 5.252 17.326 00-.004.004 4.295 5.252 17.326 00-.071.068 4.295 5.252 17.326 00-.074.072 4.295 5.252 17.326 00-.067.067 4.295 5.252 17.326 00-.021.023 4.295 5.252 17.326 00-.028.029 4.295 5.252 17.326 00-.053.056 4.295 5.252 17.326 00-.027.03 4.295 5.252 17.326 00-.027.03 4.295 5.252 17.326 00-.058.066 4.295 5.252 17.326 00-.05.058 4.295 5.252 17.326 00-.034.042 4.295 5.252 17.326 00-.037.044 4.295 5.252 17.326 00-.036.046 4.295 5.252 17.326 00-.02.024 4.295 5.252 17.326 00-.036.046 4.295 5.252 17.326 00-.02.026 4.295 5.252 17.326 00-.03.04 4.295 5.252 17.326 00-.057.078 4.295 5.252 17.326 00-.014.019 4.295 5.252 17.326 00-.046.065 4.295 5.252 17.326 00-.01.013 4.295 5.252 17.326 00-.055.082 4.295 5.252 17.326 00-.055.084 4.295 5.252 17.326 00-.008.012 4.295 5.252 17.326 00-.052.083 4.295 5.252 17.326 00-.056.09 4.295 5.252 17.326 00-.045.08 4.295 5.252 17.326 00-.023.04 4.295 5.252 17.326 00-.025.043 4.295 5.252 17.326 00-.02.036 4.295 5.252 17.326 00-.043.08 4.295 5.252 17.326 00-.05.096 4.295 5.252 17.326 00-.04.083 4.295 5.252 17.326 00-.018.035 4.295 5.252 17.326 00-.027.056 4.295 5.252 17.326 00-.02.046 4.295 5.252 17.326 00-.017.034 4.295 5.252 17.326 00-.032.074 4.295 5.252 17.326 00-.017.04 4.295 5.252 17.326 00-.023.052 4.295 5.252 17.326 00-.012.03 4.295 5.252 17.326 00-.037.091 4.295 5.252 17.326 00-.03.076 4.295 5.252 17.326 00-.018.049 4.295 5.252 17.326 00-.009.024 4.295 5.252 17.326 00-.019.053 4.295 5.252 17.326 00-.024.07 4.295 5.252 17.326 00-.022.063 4.295 5.252 17.326 00-.015.048 4.295 5.252 17.326 00-.017.053 4.295 5.252 17.326 00-.009.03 4.295 5.252 17.326 00-.024.081 4.295 5.252 17.326 00-.01.036 4.295 5.252 17.326 00-.015.053 4.295 5.252 17.326 00-.012.043 4.295 5.252 17.326 00-.02.076 4.295 5.252 17.326 00-.009.029 4.295 5.252 17.326 00-.014.06 4.295 5.252 17.326 00-.02.08 4.295 5.252 17.326 000 .002 4.295 5.252 17.326 00-.023.105 4.295 5.252 17.326 000 .001 4.295 5.252 17.326 00-.018.09 4.295 5.252 17.326 00-.003.014 4.295 5.252 17.326 00-.01.05 4.295 5.252 17.326 00-.018.107 4.295 5.252 17.326 00-.012.075 4.295 5.252 17.326 00-.012.081 4.295 5.252 17.326 00-.015.104 4.295 5.252 17.326 000 .004 4.295 5.252 17.326 00-.012.104 4.295 5.252 17.326 00-.006.057 4.295 5.252 17.326 00-.009.1 4.295 5.252 17.326 000 .012 4.295 5.252 17.326 00-.007.086 4.295 5.252 17.326 00-.002.038 4.295 5.252 17.326 00-.003.053 4.295 5.252 17.326 00-.002.043 4.295 5.252 17.326 00-.003.071 4.295 5.252 17.326 00-.002.061 4.295 5.252 17.326 000 .02 4.295 5.252 17.326 000 .06 4.295 5.252 17.326 000 .089 4.295 5.252 17.326 000 .002 4.295 5.252 17.326 000 .05 4.295 5.252 17.326 00.002.106 4.295 5.252 17.326 00.003.078 4.295 5.252 17.326 00.004.081 4.295 5.252 17.326 00.006.087 4.295 5.252 17.326 00.003.036 4.295 5.252 17.326 00.008.086 4.295 5.252 17.326 00.007.067 4.295 5.252 17.326 00.021.177 4.295 5.252 17.326 00.006.04 4.295 5.252 17.326 00.007.044 4.295 5.252 17.326 00.007.044 4.295 5.252 17.326 00.012.071 4.295 5.252 17.326 00.008.04 4.295 5.252 17.326 00.012.059 4.295 5.252 17.326 00.004.024 4.295 5.252 17.326 00.017.085 4.295 5.252 17.326 00.004.019 4.295 5.252 17.326 00.015.07 4.295 5.252 17.326 00.01.035 4.295 5.252 17.326 00.02.08 4.295 5.252 17.326 000 .002 4.295 5.252 17.326 00.019.072 4.295 5.252 17.326 00.013.048 4.295 5.252 17.326 00.008.027 4.295 5.252 17.326 00.014.046 4.295 5.252 17.326 00.024.078 4.295 5.252 17.326 00.006.017 4.295 5.252 17.326 00.017.05 4.295 5.252 17.326 00.024.073 4.295 5.252 17.326 00.021.058 4.295 5.252 17.326 00.006.016 4.295 5.252 17.326 00.024.064 4.295 5.252 17.326 00.016.041 4.295 5.252 17.326 00.026.065 4.295 5.252 17.326 00.006.014 4.295 5.252 17.326 00.024.058 4.295 5.252 17.326 00.032.071 4.295 5.252 17.326 00.024.053 4.295 5.252 17.326 00.031.067 4.295 5.252 17.326 00.016.033 4.295 5.252 17.326 00.019.037 4.295 5.252 17.326 00.037.073 4.295 5.252 17.326 00.034.064 4.295 5.252 17.326 00.023.04 4.295 5.252 17.326 00.011.02 4.295 5.252 17.326 00.025.044 4.295 5.252 17.326 00.04.067 4.295 5.252 17.326 00.026.043 4.295 5.252 17.326 00.012.019 4.295 5.252 17.326 00.043.068 4.295 5.252 17.326 00.007.01 4.295 5.252 17.326 00.038.057 4.295 5.252 17.326 00.028.04 4.295 5.252 17.326 00.016.024 4.295 5.252 17.326 00.05.068 4.295 5.252 17.326 00.054.073 4.295 5.252 17.326 00.004.005 4.295 5.252 17.326 00.038.049 4.295 5.252 17.326 00.043.053 4.295 5.252 17.326 00.007.008 4.295 5.252 17.326 00.055.064 4.295 5.252 17.326 00.002.003 4.295 5.252 17.326 00.06.068 4.295 5.252 17.326 00.05.055 4.295 5.252 17.326 00.036.038 4.295 5.252 17.326 00.019.019 4.295 5.252 17.326 00.035.036 4.295 5.252 17.326 00.035.034 4.295 5.252 17.326 00.049.047 4.295 5.252 17.326 00.003.004 4.295 5.252 17.326 00.045.041 4.295 5.252 17.326 00.053.047 4.295 5.252 17.326 00.058.05 4.295 5.252 17.326 00.03.025 4.295 5.252 17.326 00.034.027 4.295 5.252 17.326 00.027.022 4.295 5.252 17.326 00.047.036 4.295 5.252 17.326 00.014.011 4.295 5.252 17.326 00.046.033 4.295 5.252 17.326 00.043.032 4.295 5.252 17.326 00.05.036 4.295 5.252 17.326 00.01.006 4.295 5.252 17.326 00.063.042 4.295 5.252 17.326 00.018.011 4.295 5.252 17.326 00.066.041 4.295 5.252 17.326 00.07.043 4.295 5.252 17.326 00.018.01 4.295 5.252 17.326 00.046.026 4.295 5.252 17.326 00.058.03 4.295 5.252 17.326 00.006.004 4.295 5.252 17.326 00.062.032 4.295 5.252 17.326 00.028.014 4.295 5.252 17.326 00.055.026 4.295 5.252 17.326 00.027.013 4.295 5.252 17.326 00.036.016 4.295 5.252 17.326 00.052.023 4.295 5.252 17.326 00.045.02 4.295 5.252 17.326 00.02.007 4.295 5.252 17.326 00.064.025 4.295 5.252 17.326 00.021.008 4.295 5.252 17.326 00.064.024 4.295 5.252 17.326 00.027.009 4.295 5.252 17.326 00.03.01 4.295 5.252 17.326 00.06.02 4.295 5.252 17.326 00.042.013 4.295 5.252 17.326 00.034.01 4.295 5.252 17.326 00.069.019 4.295 5.252 17.326 00.08.02 4.295 5.252 17.326 00.009.003 4.295 5.252 17.326 00.062.014 4.295 5.252 17.326 00.061.013 4.295 5.252 17.326 00.087.016 4.295 5.252 17.326 00.088.014 4.295 5.252 17.326 00.087.013 4.295 5.252 17.326 00.088.01 4.295 5.252 17.326 005.148-4.62 4.295 5.252 17.326 00-2.543-5.49 4.295 5.252 17.326 00-.002 0 4.295 5.252 17.326 00-.155-.053 4.295 5.252 17.326 00-.03-.01 4.295 5.252 17.326 00-.064-.019 4.295 5.252 17.326 00-.068-.019 4.295 5.252 17.326 00-.018-.005 4.295 5.252 17.326 00-.02-.004 4.295 5.252 17.326 00-.008-.003 4.295 5.252 17.326 00-.075-.018 4.295 5.252 17.326 00-.002 0 4.295 5.252 17.326 00-.006-.001 4.295 5.252 17.326 00-.08-.018 4.295 5.252 17.326 00-.003 0 4.295 5.252 17.326 00-.086-.016 4.295 5.252 17.326 00-.087-.015 4.295 5.252 17.326 00-.087-.012 4.295 5.252 17.326 00-.042-.005 4.295 5.252 17.326 00-.17-.015 4.295 5.252 17.326 00-.008 0 4.295 5.252 17.326 00-.011-.001 4.295 5.252 17.326 00-.071-.003 4.295 5.252 17.326 00-.007 0 4.295 5.252 17.326 00-.007 0 4.295 5.252 17.326 00-.082-.003 4.295 5.252 17.326 00-.048-.001z",
    paintOrder: "fill markers stroke"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    strokeWidth: 1.509,
    paintOrder: "fill markers stroke",
    transform: "matrix(-.61642 .451 -.47696 -.55885 290.47 34.762)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 139.392,
    cy: -74.041,
    fill: "#370617",
    rx: 5.006,
    ry: 6.82,
    transform: "rotate(46.992)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#03071e",
    d: "M154.104 46.667a5.006 6.82 46.992 01-2.126 7.54 5.006 6.82 46.992 01-8.296 1.099 5.006 6.82 46.992 00.553.773 5.006 6.82 46.992 008.402-.99 5.006 6.82 46.992 001.573-8.314 5.006 6.82 46.992 00-.106-.108z"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    strokeWidth: 2.06,
    paintOrder: "fill markers stroke",
    transform: "matrix(-.52097 .16768 -.00162 -.57596 250.542 66.865)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 139.392,
    cy: -74.041,
    fill: "#370617",
    rx: 5.006,
    ry: 6.82,
    transform: "rotate(46.992)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#03071e",
    d: "M154.104 46.667a5.006 6.82 46.992 01-2.126 7.54 5.006 6.82 46.992 01-8.296 1.099 5.006 6.82 46.992 00.553.773 5.006 6.82 46.992 008.402-.99 5.006 6.82 46.992 001.573-8.314 5.006 6.82 46.992 00-.106-.108z"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    strokeWidth: 3.998,
    paintOrder: "fill markers stroke",
    transform: "matrix(-.0979 .35013 -.18543 -.1516 192.135 33.27)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 139.392,
    cy: -74.041,
    fill: "#370617",
    rx: 5.006,
    ry: 6.82,
    transform: "rotate(46.992)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#03071e",
    d: "M154.104 46.667a5.006 6.82 46.992 01-2.126 7.54 5.006 6.82 46.992 01-8.296 1.099 5.006 6.82 46.992 00.553.773 5.006 6.82 46.992 008.402-.99 5.006 6.82 46.992 001.573-8.314 5.006 6.82 46.992 00-.106-.108z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#cb6906",
    fillRule: "evenodd",
    d: "M224.062 92.236a5.552 7.102 34.52 00-6.15 3.864 5.552 7.102 34.52 00.24 8.182 5.552 7.102 34.52 00.006.006 5.552 7.102 34.52 00.055.052 5.552 7.102 34.52 00.022.02 5.552 7.102 34.52 00.06.053 5.552 7.102 34.52 00.01.008 5.552 7.102 34.52 00.07.06 5.552 7.102 34.52 00.072.059 5.552 7.102 34.52 00.012.01 5.552 7.102 34.52 00.055.043 5.552 7.102 34.52 00.038.029 5.552 7.102 34.52 00.046.033 5.552 7.102 34.52 00.013.01 5.552 7.102 34.52 00.044.032 5.552 7.102 34.52 00.082.057 5.552 7.102 34.52 00.079.052 5.552 7.102 34.52 00.012.007 5.552 7.102 34.52 00.068.043 5.552 7.102 34.52 00.013.007 5.552 7.102 34.52 00.082.048 5.552 7.102 34.52 00.036.02 5.552 7.102 34.52 00.087.049 5.552 7.102 34.52 00.09.046 5.552 7.102 34.52 00.18.086 5.552 7.102 34.52 00.092.04 5.552 7.102 34.52 00.078.032 5.552 7.102 34.52 00.027.011 5.552 7.102 34.52 00.177.065 5.552 7.102 34.52 00.194.063 5.552 7.102 34.52 00.098.028 5.552 7.102 34.52 00.298.07 5.552 7.102 34.52 00.101.02 5.552 7.102 34.52 00.1.017 5.552 7.102 34.52 00.007 0 5.552 7.102 34.52 00.098.015 5.552 7.102 34.52 00.104.013 5.552 7.102 34.52 00.104.011 5.552 7.102 34.52 00.104.008 5.552 7.102 34.52 00.105.006 5.552 7.102 34.52 00.106.004 5.552 7.102 34.52 00.212.003 5.552 7.102 34.52 00.215-.006 5.552 7.102 34.52 00.108-.006 5.552 7.102 34.52 00.216-.019 5.552 7.102 34.52 00.218-.027 5.552 7.102 34.52 00.109-.017 5.552 7.102 34.52 00.219-.04 5.552 7.102 34.52 00.109-.023 5.552 7.102 34.52 00.101-.024 5.552 7.102 34.52 00.008-.002 5.552 7.102 34.52 00.065-.016 5.552 7.102 34.52 00.045-.011 5.552 7.102 34.52 00.017-.005 5.552 7.102 34.52 00.092-.025 5.552 7.102 34.52 00.065-.018 5.552 7.102 34.52 00.019-.006 5.552 7.102 34.52 00.068-.02 5.552 7.102 34.52 00.022-.006 5.552 7.102 34.52 00.045-.015 5.552 7.102 34.52 00.109-.035 5.552 7.102 34.52 00.105-.037 5.552 7.102 34.52 00.003 0 5.552 7.102 34.52 00.007-.003 5.552 7.102 34.52 00.103-.038 5.552 7.102 34.52 00.108-.041 5.552 7.102 34.52 00.064-.026 5.552 7.102 34.52 00.045-.018 5.552 7.102 34.52 00.013-.006 5.552 7.102 34.52 00.095-.04 5.552 7.102 34.52 00.094-.041 5.552 7.102 34.52 00.013-.006 5.552 7.102 34.52 00.021-.01 5.552 7.102 34.52 00.087-.04 5.552 7.102 34.52 00.106-.052 5.552 7.102 34.52 00.106-.054 5.552 7.102 34.52 00.063-.032 5.552 7.102 34.52 00.043-.023 5.552 7.102 34.52 00.013-.007 5.552 7.102 34.52 00.093-.05 5.552 7.102 34.52 00.087-.05 5.552 7.102 34.52 00.018-.01 5.552 7.102 34.52 00.025-.014 5.552 7.102 34.52 00.079-.047 5.552 7.102 34.52 00.092-.056 5.552 7.102 34.52 00.012-.007 5.552 7.102 34.52 00.06-.037 5.552 7.102 34.52 00.043-.027 5.552 7.102 34.52 00.02-.014 5.552 7.102 34.52 00.082-.053 5.552 7.102 34.52 00.102-.068 5.552 7.102 34.52 00.1-.07 5.552 7.102 34.52 00.086-.06 5.552 7.102 34.52 00.015-.012 5.552 7.102 34.52 00.058-.042 5.552 7.102 34.52 00.041-.031 5.552 7.102 34.52 00.058-.044 5.552 7.102 34.52 00.04-.032 5.552 7.102 34.52 00.088-.069 5.552 7.102 34.52 00.01-.007 5.552 7.102 34.52 00.056-.046 5.552 7.102 34.52 00.04-.032 5.552 7.102 34.52 00.019-.016 5.552 7.102 34.52 00.077-.065 5.552 7.102 34.52 00.056-.047 5.552 7.102 34.52 00.039-.034 5.552 7.102 34.52 00.055-.049 5.552 7.102 34.52 00.08-.072 5.552 7.102 34.52 00.013-.012 5.552 7.102 34.52 00.038-.035 5.552 7.102 34.52 00.081-.076 5.552 7.102 34.52 00.01-.01 5.552 7.102 34.52 00.054-.052 5.552 7.102 34.52 00.037-.036 5.552 7.102 34.52 00.021-.02 5.552 7.102 34.52 00.068-.07 5.552 7.102 34.52 00.089-.09 5.552 7.102 34.52 00.052-.054 5.552 7.102 34.52 00.035-.038 5.552 7.102 34.52 00.05-.054 5.552 7.102 34.52 00.036-.04 5.552 7.102 34.52 00.007-.006 5.552 7.102 34.52 00.078-.088 5.552 7.102 34.52 00.05-.056 5.552 7.102 34.52 00.034-.04 5.552 7.102 34.52 00.021-.025 5.552 7.102 34.52 00.06-.072 5.552 7.102 34.52 00.081-.098 5.552 7.102 34.52 00.047-.058 5.552 7.102 34.52 00.033-.042 5.552 7.102 34.52 00.046-.058 5.552 7.102 34.52 00.032-.042 5.552 7.102 34.52 00.046-.06 5.552 7.102 34.52 00.031-.042 5.552 7.102 34.52 00.045-.06 5.552 7.102 34.52 00.03-.043 5.552 7.102 34.52 00.044-.061 5.552 7.102 34.52 00.03-.043 5.552 7.102 34.52 00.043-.062 5.552 7.102 34.52 00.063-.093 5.552 7.102 34.52 00.008-.013 5.552 7.102 34.52 00.003-.005 5.552 7.102 34.52 00.067-.101 5.552 7.102 34.52 00.064-.1 5.552 7.102 34.52 00.004-.007 5.552 7.102 34.52 00.028-.044 5.552 7.102 34.52 00.066-.11 5.552 7.102 34.52 00.027-.044 5.552 7.102 34.52 00.038-.065 5.552 7.102 34.52 00.026-.045 5.552 7.102 34.52 00.037-.066 5.552 7.102 34.52 00.025-.046 5.552 7.102 34.52 00.037-.066 5.552 7.102 34.52 00.024-.045 5.552 7.102 34.52 00.06-.113 5.552 7.102 34.52 00.057-.113 5.552 7.102 34.52 00.033-.067 5.552 7.102 34.52 00.023-.047 5.552 7.102 34.52 00.032-.067 5.552 7.102 34.52 00.022-.047 5.552 7.102 34.52 00.031-.068 5.552 7.102 34.52 00.021-.047 5.552 7.102 34.52 00.01-.021 5.552 7.102 34.52 00.037-.086 5.552 7.102 34.52 00.003-.008 5.552 7.102 34.52 00.029-.069 5.552 7.102 34.52 00.047-.114 5.552 7.102 34.52 000-.003 5.552 7.102 34.52 00.02-.047 5.552 7.102 34.52 00.027-.07 5.552 7.102 34.52 00.007-.017 5.552 7.102 34.52 00.037-.098 5.552 7.102 34.52 000-.004 5.552 7.102 34.52 00.018-.046 5.552 7.102 34.52 00.025-.07 5.552 7.102 34.52 00.003-.01 5.552 7.102 34.52 00.028-.082 5.552 7.102 34.52 00.01-.026 5.552 7.102 34.52 00.015-.048 5.552 7.102 34.52 00.023-.07 5.552 7.102 34.52 00.015-.049 5.552 7.102 34.52 00.001-.003 5.552 7.102 34.52 00.036-.115 5.552 7.102 34.52 00.034-.12 5.552 7.102 34.52 00.029-.104 5.552 7.102 34.52 00.003-.014 5.552 7.102 34.52 00.018-.07 5.552 7.102 34.52 00.013-.05 5.552 7.102 34.52 00.007-.029 5.552 7.102 34.52 00.02-.082 5.552 7.102 34.52 00.002-.008 5.552 7.102 34.52 00.016-.07 5.552 7.102 34.52 00.023-.105 5.552 7.102 34.52 00.003-.014 5.552 7.102 34.52 00.002-.012 5.552 7.102 34.52 00.015-.077 5.552 7.102 34.52 00.005-.031 5.552 7.102 34.52 00.01-.049 5.552 7.102 34.52 00.017-.1 5.552 7.102 34.52 00.003-.02 5.552 7.102 34.52 00.011-.07 5.552 7.102 34.52 00.008-.048 5.552 7.102 34.52 00.003-.02 5.552 7.102 34.52 00.015-.1 5.552 7.102 34.52 00.013-.105 5.552 7.102 34.52 00.002-.013 5.552 7.102 34.52 00.008-.07 5.552 7.102 34.52 00.001-.015 5.552 7.102 34.52 00.01-.104 5.552 7.102 34.52 00.009-.086 5.552 7.102 34.52 00.004-.054 5.552 7.102 34.52 00.007-.096 5.552 7.102 34.52 00.006-.11 5.552 7.102 34.52 000-.008 5.552 7.102 34.52 000-.003 5.552 7.102 34.52 00.007-.231 5.552 7.102 34.52 00.001-.116 5.552 7.102 34.52 00-.001-.095 5.552 7.102 34.52 000-.021 5.552 7.102 34.52 00-.001-.048 5.552 7.102 34.52 00-.001-.026 5.552 7.102 34.52 00-.003-.082 5.552 7.102 34.52 000-.007 5.552 7.102 34.52 00-.003-.068 5.552 7.102 34.52 00-.005-.1 5.552 7.102 34.52 00-.001-.013 5.552 7.102 34.52 00-.001-.015 5.552 7.102 34.52 00-.008-.092 5.552 7.102 34.52 000-.007 5.552 7.102 34.52 00-.001-.004 5.552 7.102 34.52 00-.008-.087 5.552 7.102 34.52 00-.002-.022 5.552 7.102 34.52 00-.005-.046 5.552 7.102 34.52 00-.008-.066 5.552 7.102 34.52 00-.005-.046 5.552 7.102 34.52 00-.002-.011 5.552 7.102 34.52 00-.014-.1 5.552 7.102 34.52 00-.015-.091 5.552 7.102 34.52 00-.003-.02 5.552 7.102 34.52 00-.012-.064 5.552 7.102 34.52 00-.008-.045 5.552 7.102 34.52 00-.003-.017 5.552 7.102 34.52 00-.017-.086 5.552 7.102 34.52 00-.001-.005 5.552 7.102 34.52 00-.014-.064 5.552 7.102 34.52 00-.01-.044 5.552 7.102 34.52 00-.015-.063 5.552 7.102 34.52 00-.01-.043 5.552 7.102 34.52 00-.006-.022 5.552 7.102 34.52 00-.018-.073 5.552 7.102 34.52 00-.003-.011 5.552 7.102 34.52 00-.018-.062 5.552 7.102 34.52 00-.025-.086 5.552 7.102 34.52 00-.005-.018 5.552 7.102 34.52 00-.013-.043 5.552 7.102 34.52 00-.02-.06 5.552 7.102 34.52 00-.001-.006 5.552 7.102 34.52 00-.023-.067 5.552 7.102 34.52 00-.025-.07 5.552 7.102 34.52 00-.034-.094 5.552 7.102 34.52 00-.002-.007 5.552 7.102 34.52 00-.023-.059 5.552 7.102 34.52 00-.005-.015 5.552 7.102 34.52 00-.022-.054 5.552 7.102 34.52 00-.024-.058 5.552 7.102 34.52 00-.004-.011 5.552 7.102 34.52 00-.025-.057 5.552 7.102 34.52 00-.018-.04 5.552 7.102 34.52 00-.025-.056 5.552 7.102 34.52 00-.008-.017 5.552 7.102 34.52 00-.035-.073 5.552 7.102 34.52 00-.002-.004 5.552 7.102 34.52 00-.02-.039 5.552 7.102 34.52 00-.01-.02 5.552 7.102 34.52 00-.033-.063 5.552 7.102 34.52 00-.004-.01 5.552 7.102 34.52 00-.029-.054 5.552 7.102 34.52 00-.041-.074 5.552 7.102 34.52 00-.01-.016 5.552 7.102 34.52 00-.034-.06 5.552 7.102 34.52 00-.018-.03 5.552 7.102 34.52 00-.008-.012 5.552 7.102 34.52 00-.047-.075 5.552 7.102 34.52 00-.046-.072 5.552 7.102 34.52 00-.009-.015 5.552 7.102 34.52 00-.023-.034 5.552 7.102 34.52 00-.005-.01 5.552 7.102 34.52 00-.051-.073 5.552 7.102 34.52 00-.001-.001 5.552 7.102 34.52 00-.035-.05 5.552 7.102 34.52 00-.01-.013 5.552 7.102 34.52 00-.05-.068 5.552 7.102 34.52 00-.052-.067 5.552 7.102 34.52 00-.01-.014 5.552 7.102 34.52 00-.027-.032 5.552 7.102 34.52 00-.038-.046 5.552 7.102 34.52 00-.027-.032 5.552 7.102 34.52 00-.038-.045 5.552 7.102 34.52 00-.007-.007 5.552 7.102 34.52 00-.057-.063 5.552 7.102 34.52 00-.003-.005 5.552 7.102 34.52 00-.028-.03 5.552 7.102 34.52 00-.004-.005 5.552 7.102 34.52 00-.064-.067 5.552 7.102 34.52 000-.001 5.552 7.102 34.52 00-.003-.002 5.552 7.102 34.52 00-.058-.059 5.552 7.102 34.52 00-.01-.01 5.552 7.102 34.52 00-.043-.041 5.552 7.102 34.52 00-.03-.028 5.552 7.102 34.52 00-.043-.04 5.552 7.102 34.52 00-.03-.028 5.552 7.102 34.52 00-.016-.014 5.552 7.102 34.52 00-.05-.044 5.552 7.102 34.52 00-.01-.008 5.552 7.102 34.52 00-.045-.038 5.552 7.102 34.52 00-.001 0 5.552 7.102 34.52 00-.07-.058 5.552 7.102 34.52 00-.006-.005 5.552 7.102 34.52 00-.007-.005 5.552 7.102 34.52 00-.065-.05 5.552 7.102 34.52 00-.007-.006 5.552 7.102 34.52 00-.004-.003 5.552 7.102 34.52 00-.058-.043 5.552 7.102 34.52 00-.018-.013 5.552 7.102 34.52 00-.034-.024 5.552 7.102 34.52 00-.048-.033 5.552 7.102 34.52 00-.034-.024 5.552 7.102 34.52 00-.014-.009 5.552 7.102 34.52 00-.06-.04 5.552 7.102 34.52 00-.01-.006 5.552 7.102 34.52 00-.05-.03 5.552 7.102 34.52 00-.006-.005 5.552 7.102 34.52 00-.06-.037 5.552 7.102 34.52 00-.019-.01 5.552 7.102 34.52 00-.035-.021 5.552 7.102 34.52 00-.088-.049 5.552 7.102 34.52 00-.059-.032 5.552 7.102 34.52 00-2.251-.528z",
    paintOrder: "fill markers stroke"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    strokeWidth: 1.162,
    paintOrder: "fill markers stroke",
    transform: "matrix(.9194 -.2524 .28693 .94892 70.937 87.804)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 139.392,
    cy: -74.041,
    fill: "#370617",
    rx: 5.006,
    ry: 6.82,
    transform: "rotate(46.992)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#03071e",
    d: "M154.104 46.667a5.006 6.82 46.992 01-2.126 7.54 5.006 6.82 46.992 01-8.296 1.099 5.006 6.82 46.992 00.553.773 5.006 6.82 46.992 008.402-.99 5.006 6.82 46.992 001.573-8.314 5.006 6.82 46.992 00-.106-.108z"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    strokeWidth: 1.731,
    paintOrder: "fill markers stroke",
    transform: "matrix(.28932 -.5279 .67106 .24629 157.95 129.12)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 139.392,
    cy: -74.041,
    fill: "#370617",
    rx: 5.006,
    ry: 6.82,
    transform: "rotate(46.992)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#03071e",
    d: "M154.104 46.667a5.006 6.82 46.992 01-2.126 7.54 5.006 6.82 46.992 01-8.296 1.099 5.006 6.82 46.992 00.553.773 5.006 6.82 46.992 008.402-.99 5.006 6.82 46.992 001.573-8.314 5.006 6.82 46.992 00-.106-.108z"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    strokeWidth: 2.228,
    paintOrder: "fill markers stroke",
    transform: "matrix(.5096 .18201 -.05659 .48391 134.575 56.39)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 139.392,
    cy: -74.041,
    fill: "#370617",
    rx: 5.006,
    ry: 6.82,
    transform: "rotate(46.992)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#03071e",
    d: "M154.104 46.667a5.006 6.82 46.992 01-2.126 7.54 5.006 6.82 46.992 01-8.296 1.099 5.006 6.82 46.992 00.553.773 5.006 6.82 46.992 008.402-.99 5.006 6.82 46.992 001.573-8.314 5.006 6.82 46.992 00-.106-.108z"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    strokeWidth: 2.115,
    paintOrder: "fill markers stroke",
    transform: "matrix(.42854 -.31692 .3384 .41486 152.138 109.237)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 139.392,
    cy: -74.041,
    fill: "#370617",
    rx: 5.006,
    ry: 6.82,
    transform: "rotate(46.992)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#03071e",
    d: "M154.104 46.667a5.006 6.82 46.992 01-2.126 7.54 5.006 6.82 46.992 01-8.296 1.099 5.006 6.82 46.992 00.553.773 5.006 6.82 46.992 008.402-.99 5.006 6.82 46.992 001.573-8.314 5.006 6.82 46.992 00-.106-.108z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 202.078,
    cy: 111.607,
    fill: "#370617",
    fillRule: "evenodd",
    paintOrder: "fill markers stroke",
    rx: 1.143,
    ry: 1.16
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 202.671,
    cy: 105.883,
    fill: "#370617",
    fillRule: "evenodd",
    paintOrder: "fill markers stroke",
    rx: 0.717,
    ry: 0.752
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 213.666,
    cy: 108.532,
    fill: "#370617",
    fillRule: "evenodd",
    paintOrder: "fill markers stroke",
    rx: 0.717,
    ry: 0.752
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 211.88,
    cy: 100.858,
    fill: "#370617",
    fillRule: "evenodd",
    paintOrder: "fill markers stroke",
    rx: 0.876,
    ry: 0.898
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 173.497,
    cy: 95.559,
    fill: "#7b0208",
    fillRule: "evenodd",
    paintOrder: "fill markers stroke",
    rx: 0.767,
    ry: 0.666
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 200.985,
    cy: -69.881,
    fill: "#7b0208",
    fillRule: "evenodd",
    paintOrder: "fill markers stroke",
    rx: 0.767,
    ry: 1.209,
    transform: "rotate(47.63)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -43.835,
    cy: 200.54,
    fill: "#7b0208",
    fillRule: "evenodd",
    paintOrder: "fill markers stroke",
    rx: 1.278,
    ry: 1.497,
    transform: "rotate(-73.97)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -7.694,
    cy: 250.425,
    fill: "#6a0006",
    fillRule: "evenodd",
    paintOrder: "fill markers stroke",
    rx: 1.278,
    ry: 1.497,
    transform: "rotate(-73.97)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -7.5,
    cy: 250.76,
    fill: "#7b0208",
    fillRule: "evenodd",
    paintOrder: "fill markers stroke",
    rx: 1.278,
    ry: 1.497,
    transform: "rotate(-73.97)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 212.134,
    cy: -131.988,
    fill: "#620207",
    fillRule: "evenodd",
    paintOrder: "fill markers stroke",
    rx: 0.767,
    ry: 1.209,
    transform: "rotate(47.63)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 212.409,
    cy: -132.432,
    fill: "#7b0208",
    fillRule: "evenodd",
    paintOrder: "fill markers stroke",
    rx: 0.767,
    ry: 1.209,
    transform: "rotate(47.63)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 233.355,
    cy: 54.638,
    fill: "#7b0208",
    fillRule: "evenodd",
    paintOrder: "fill markers stroke",
    rx: 0.767,
    ry: 0.666
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 205.262,
    cy: 70.261,
    fill: "#7b0208",
    fillRule: "evenodd",
    paintOrder: "fill markers stroke",
    rx: 0.767,
    ry: 0.666
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 207.864,
    cy: 67.723,
    fill: "#7b0208",
    fillRule: "evenodd",
    paintOrder: "fill markers stroke",
    rx: 0.767,
    ry: 0.666
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 208.404,
    cy: 69.672,
    fill: "#cb6906",
    fillRule: "evenodd",
    paintOrder: "fill markers stroke",
    rx: 0.767,
    ry: 0.666
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 208.44,
    cy: 69.523,
    fill: "#7b0208",
    fillRule: "evenodd",
    paintOrder: "fill markers stroke",
    rx: 0.767,
    ry: 0.666
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1.602,
    transform: "matrix(.5342 .30226 -.28416 .56823 43.35 -51.954)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#cosmos-q)",
    d: "M155.102 25.595v32.078h2.686V25.035z",
    filter: "url(#cosmos-r)",
    transform: "matrix(.95693 0 0 1 6.68 0)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 156.377,
    cy: 57.68,
    fill: "#4cc8f0",
    fillOpacity: 0.969,
    fillRule: "evenodd",
    stroke: "#3a0ca3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.03,
    strokeWidth: 0.324,
    filter: "url(#cosmos-s)",
    paintOrder: "fill markers stroke",
    rx: 1.211,
    ry: 1.314,
    transform: "matrix(1.42896 0 0 1.1999 -66.998 -11.507)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1.602,
    transform: "matrix(.52187 .32308 -.30634 .55658 -49.622 24.108)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#cosmos-t)",
    d: "M155.102 25.595v32.078h2.686V25.035z",
    filter: "url(#cosmos-r)",
    transform: "matrix(.95693 0 0 1 6.68 0)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 156.377,
    cy: 57.68,
    fill: "#4cc8f0",
    fillOpacity: 0.969,
    fillRule: "evenodd",
    stroke: "#3a0ca3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.03,
    strokeWidth: 0.324,
    filter: "url(#cosmos-s)",
    paintOrder: "fill markers stroke",
    rx: 1.211,
    ry: 1.314,
    transform: "matrix(1.42896 0 0 1.1999 -66.998 -11.507)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#5815ef",
    fillOpacity: 0.847,
    fillRule: "evenodd",
    strokeWidth: 6,
    filter: "url(#cosmos-u)",
    paintOrder: "fill markers stroke",
    transform: "translate(-10.676 -.05) scale(.16666)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 204.492,
    cy: 101.26,
    rx: 40.866,
    ry: 36.429
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 198.838,
    cy: 126.712,
    rx: 9.695,
    ry: 3.515
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 203.78,
    cy: 130.648,
    rx: 4.558,
    ry: 2.68
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 178.698,
    cy: 117.938,
    rx: 4.558,
    ry: 2.68
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 212.179,
    cy: 125.353,
    rx: 4.558,
    ry: 2.68
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    strokeWidth: 6,
    paintOrder: "fill markers stroke",
    transform: "translate(-10.676 -.05) scale(.16666)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 204.492,
    cy: 101.26,
    fill: "url(#cosmos-v)",
    rx: 40.866,
    ry: 36.429
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 198.838,
    cy: 126.712,
    fill: "#290874",
    fillOpacity: 0.847,
    rx: 9.695,
    ry: 3.515
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 203.78,
    cy: 130.648,
    fill: "#290874",
    fillOpacity: 0.847,
    rx: 4.558,
    ry: 2.68
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 178.698,
    cy: 117.938,
    fill: "#2d097e",
    rx: 4.558,
    ry: 2.68
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 212.179,
    cy: 125.353,
    fill: "#290874",
    fillOpacity: 0.847,
    rx: 4.558,
    ry: 2.68
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.648,
    cy: 59.877,
    fill: "#fff",
    fillOpacity: 0.847,
    fillRule: "evenodd",
    filter: "url(#cosmos-w)",
    paintOrder: "fill markers stroke",
    rx: 1.271,
    ry: 1.128,
    transform: "matrix(.57793 0 0 .55887 5.224 25.916)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.648,
    cy: 59.877,
    fill: "#fff",
    fillOpacity: 0.847,
    fillRule: "evenodd",
    filter: "url(#cosmos-w)",
    paintOrder: "fill markers stroke",
    rx: 1.271,
    ry: 1.128,
    transform: "matrix(.57793 0 0 .55887 12.387 41.187)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.648,
    cy: 59.877,
    fill: "#fff",
    fillOpacity: 0.847,
    fillRule: "evenodd",
    filter: "url(#cosmos-w)",
    paintOrder: "fill markers stroke",
    rx: 1.271,
    ry: 1.128,
    transform: "matrix(.57793 0 0 .55887 37.786 77.411)"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.648,
    cy: 59.877,
    fill: "#fff",
    fillOpacity: 0.847,
    fillRule: "evenodd",
    filter: "url(#cosmos-w)",
    paintOrder: "fill markers stroke",
    rx: 1.271,
    ry: 1.128,
    transform: "matrix(.57793 0 0 .55887 27.043 92.319)"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.648,
    cy: 59.877,
    fill: "#fff",
    fillOpacity: 0.847,
    fillRule: "evenodd",
    filter: "url(#cosmos-w)",
    paintOrder: "fill markers stroke",
    rx: 1.271,
    ry: 1.128,
    transform: "matrix(.57793 0 0 .55887 112.567 6.926)"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.648,
    cy: 59.877,
    fill: "#fff",
    fillOpacity: 0.847,
    fillRule: "evenodd",
    filter: "url(#cosmos-w)",
    paintOrder: "fill markers stroke",
    rx: 1.271,
    ry: 1.128,
    transform: "matrix(.57793 0 0 .55887 103.589 69.72)"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.648,
    cy: 59.877,
    fill: "#fff",
    fillOpacity: 0.847,
    fillRule: "evenodd",
    filter: "url(#cosmos-w)",
    paintOrder: "fill markers stroke",
    rx: 1.271,
    ry: 1.128,
    transform: "matrix(.57793 0 0 .55887 28.677 -24.206)"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.648,
    cy: 59.877,
    fill: "#fff",
    fillOpacity: 0.847,
    fillRule: "evenodd",
    filter: "url(#cosmos-w)",
    paintOrder: "fill markers stroke",
    rx: 1.271,
    ry: 1.128,
    transform: "matrix(.57793 0 0 .55887 100.113 76.594)"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.648,
    cy: 59.877,
    fill: "#fff",
    fillOpacity: 0.847,
    fillRule: "evenodd",
    filter: "url(#cosmos-w)",
    paintOrder: "fill markers stroke",
    rx: 1.271,
    ry: 1.128,
    transform: "matrix(.57793 0 0 .55887 105.938 73.97)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCosmos);
export default __webpack_public_path__ + "static/media/cosmos.f71e5ac7.svg";
export { ForwardRef as ReactComponent };